'use strict';

/*global isEmpty*/

/*exported isInteger*/
function isInteger(value) {
  var intRegex = /^-?\d+$/;
  if (!intRegex.test(value)) {
    return false;
  }

  var intVal = parseInt(value, 10);
  return parseFloat(value) === intVal && !isNaN(intVal);
}

/*exported isFloat*/
function isFloat(value) {
  var floatRegex = /^-?\d+(?:[.,]\d*?)?$/;
  if (!floatRegex.test(value)) {
    return false;
  }

  value = parseFloat(value);
  if (isNaN(value)) {
    return false;
  }

  return true;
}

/*exported isNumber*/
function isNumber(value) {
  return isInteger(value) || isFloat(value);
}

/*exported isDate*/
function isDate(value, lang) {
  if (!isEmpty(value)) {
    switch (lang) {
      case 'en' : {
        return (value.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/));
      }

      break;
      case 'cz' : {
        return (value.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})$/));
      }

      break;
    }

    return isDate(value, 'en') || isDate(value, 'cz');
  }

  return false;
}

/*exported validateInputs*/
function validateInputs($inputs, validators, parentSelector) {
  parentSelector = parentSelector || '.form-group';

  var isValid = true;
  $inputs.each(function () {
    var $input = $(this);
    var $parent = $input.closest(parentSelector);
    var value = $input.val();

    $parent.removeClass('has-error');
    $.each(validators, function (key, validator) {
      switch (validator) {
        case 'date' : {
          if (!isEmpty(value) && !isDate(value)) {
            $parent.addClass('has-error');
          }
        }

        break;
        case 'number' : {
          if (!isEmpty(value) && !isNumber(value)) {
            $parent.addClass('has-error');
          }
        }

        break;
        case 'float' : {
          if (!isEmpty(value) && !isFloat(value)) {
            $parent.addClass('has-error');
          }
        }

        break;
        case 'integer' : {
          if (!isEmpty(value) && !isInteger(value)) {
            $parent.addClass('has-error');
          }
        }

        break;
        case 'not_empty' : {
          if (isEmpty(value)) {
            $parent.addClass('has-error');
          }
        }

        break;
      }

      if ($parent.hasClass('has-error')) {
        isValid = false;
      }
    });
  });

  return isValid;
}
